import { deviceType } from "@tm/isomorphic-utils";
import styled from "styled-components";

export const BreadcrumbNav = styled.nav`
  width: 100%;
  margin: 0 auto;
`;

export const BreadcrumbContainer = styled.ol`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  background: transparent;

  @media ${deviceType.mobile} {
    padding: 0;
  }
`;

interface BreadcrumbItemProps {
  isActive?: boolean;
}

export const BreadcrumbItem = styled.li<BreadcrumbItemProps>`
  color: ${(props) => (props.isActive ? "#ffffff" : "#b3c6d9")};
  font-size: 14px;
  font-weight: ${(props) => (props.isActive ? "500" : "400")};
  line-height: 1.4;

  @media ${deviceType.mobile} {
    font-size: 12px;
  }
`;

export const BreadcrumbLink = styled.a`
  color: #b3c6d9;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }

  &:visited {
    color: #b3c6d9;
  }

  &:focus {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const BreadcrumbSeparator = styled.span`
  color: #b3c6d9;
  margin: 0 8px;
  font-size: 14px;
  user-select: none;
  font-weight: 400;

  @media ${deviceType.mobile} {
    margin: 0 6px;
    font-size: 12px;
  }
`;
